<app-menu>
    <div class="header">
        <h1>Batch Update Rates</h1>
    </div>
    <div class="body" 
    (dragover)="handleDocumentDragOver($event)"
    (dragleave)="handleDocumentDragLeave($event)"
    (drop)="handleCSVUpload($event)"
    >
        <div>
            Fill in below form or drag and drop CSV file to batch-update carrier rates.
        </div>
        <div *ngIf="isDraggingOverDocument" class="dropzone-overlay">
            Drop files here to upload
          </div>
        <form [formGroup]="updateForm">
            <mat-form-field>
                <mat-label>Contact</mat-label>
                <input matInput type="text" [matAutocomplete]="carrierAutocomplete" formControlName="contact_name">
            </mat-form-field>
            <mat-autocomplete #carrierAutocomplete="matAutocomplete" (optionSelected)="onOptionSelected($event)">
                <mat-option *ngFor="let item of filteredCarrierList" [value]="item.contact_organization" style="border-bottom: 1px solid black">
                    <span>{{item.contact_organization}}</span>
                </mat-option>
            </mat-autocomplete>
            <mat-form-field>
                <mat-label>Start Date</mat-label>
                <input matInput [matDatepicker]="start_date" formControlName="start_date"/>
                <mat-datepicker-toggle matIconSuffix [for]="start_date"></mat-datepicker-toggle>
                <mat-datepicker #start_date>
                <mat-datepicker-actions>
                    <button mat-button matDatepickerCancel>Cancel</button>
                    <button mat-raised-button color="primary" matDatepickerApply>Confirm</button>
                </mat-datepicker-actions>              
                </mat-datepicker>
            </mat-form-field>
            <mat-form-field>
                <mat-label>End Date</mat-label>
                <input matInput [matDatepicker]="end_date" formControlName="end_date"/>
                <mat-datepicker-toggle matIconSuffix [for]="end_date"></mat-datepicker-toggle>
                <mat-datepicker #end_date>
                <mat-datepicker-actions>
                    <button mat-button matDatepickerCancel>Cancel</button>
                    <button mat-raised-button color="primary" matDatepickerApply>Confirm</button>
                </mat-datepicker-actions>              
                </mat-datepicker>
            </mat-form-field>
            <mat-form-field>
                <mat-label>Rate Method</mat-label>
                <mat-select formControlName="rate_metric">
                    <mat-option *ngFor="let item of rate_metrics" [value]="item">{{item}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field>
                <mat-label>Rate Unit</mat-label>
                <mat-select formControlName="rate_unit">
                    <mat-option *ngFor="let item of rate_units" [value]="item">{{item}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field>
                <mat-label>Currency</mat-label>
                <mat-select formControlName="currency">
                    <mat-option *ngFor="let item of currencies" [value]="item">{{item}}</mat-option>
                </mat-select>
            </mat-form-field>
            <!-- List of Routes Here -->
            <div formArrayName="routes" class="routes-div">
                <h2>Routes</h2>
                <span>For origin and destination, enter either city/region or postal code.</span>
                <div *ngFor="let route of routes.controls; let i = index" [formGroupName]="i" class="route">
                    <div>
                        <!-- Autocomplete for Origin City -->
                        <mat-form-field>
                            <mat-label>Origin City</mat-label>
                            <input matInput [matAutocomplete]="originCityAuto" formControlName="origin_city" autocomplete="effoff">
                            <mat-autocomplete #originCityAuto="matAutocomplete" (optionSelected)="onCitySelected($event, 'origin', i)">
                            <mat-option *ngFor="let item of route.get('filteredOriginCities')?.value" [value]="item">
                                {{ item.accentcity }} ({{ item.rc }})
                            </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Origin Region</mat-label>
                            <input matInput type="text" formControlName="origin_region"  autocomplete="effoff">
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Origin Postal Code</mat-label>
                            <input matInput type="text" formControlName="origin_postal"  autocomplete="effoff">
                        </mat-form-field>
                         <!-- Autocomplete for Destination City -->
                        <mat-form-field>
                            <mat-label>Destination City</mat-label>
                            <input matInput [matAutocomplete]="destinationCityAuto" formControlName="destination_city" autocomplete="effoff">
                            <mat-autocomplete #destinationCityAuto="matAutocomplete" (optionSelected)="onCitySelected($event, 'destination', i)">
                            <mat-option *ngFor="let item of route.get('filteredDestinationCities')?.value" [value]="item">
                                {{ item.accentcity }} ({{ item.rc }})
                            </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Destination Region</mat-label>
                            <input matInput type="text" formControlName="destination_region"  autocomplete="effoff">
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Destination Postal Code</mat-label>
                            <input matInput type="text" formControlName="destination_postal"  autocomplete="effoff">
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field>
                            <mat-label>Transit Days</mat-label>
                            <input matInput type="number" formControlName="transit_days">
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Minimum Rate</mat-label>
                            <input matInput type="number" formControlName="min_rate">
                        </mat-form-field>
                    </div>
                    <div formArrayName="measurement_categories">
                        <h2>{{measurement_type}} Brackets</h2>
                        <div *ngFor="let category of get_measurement_categories(i).controls; let j = index" [formGroupName]="j" class="category">
                            <mat-form-field>
                                <mat-label>{{measurement_type}} Start</mat-label>
                                <input matInput type="number" formControlName="measurement_start">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>{{measurement_type}} End</mat-label>
                                <input matInput type="number" formControlName="measurement_end">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Rate {{measurement_unit}}</mat-label>
                                <input matInput type="number" formControlName="rate">
                            </mat-form-field>
                            <button mat-button (click)="remove_measurement_category(i, j)"><fa-icon [icon]="faTrash"></fa-icon></button>
                        </div>
                        <button mat-raised-button (click)="add_measurement_category(i)" color="primary">Add {{measurement_type}} Bracket</button>
                    </div>
                    <button mat-button (click)="removeRoute(i)">Remove Route</button>
                </div>
                <button mat-raised-button (click)="addRoute()" color="primary">Add Route</button>
            </div>
        </form>
        <button mat-raised-button (click)="onSubmit()" color="primary">Submit</button>
        <button mat-button color="primary" matToolTip="Download CSV template" (click)="createTemplateCSV()"><fa-icon [icon]="faFile"></fa-icon></button>
    </div>
</app-menu>